var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategorySvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33788",
    "data-name": "Group 33788",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33784",
    "data-name": "Group 33784",
    transform: "translate(6.864 6.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143146",
    "data-name": "Path 143146",
    d: "M38.11,39.136H36.026A1.026,1.026,0,0,1,35,38.11v-2.8A.307.307,0,0,1,35.306,35h2.8a1.026,1.026,0,0,1,1.026,1.026V38.11A1.026,1.026,0,0,1,38.11,39.136Zm-2.5-3.523v2.5a.412.412,0,0,0,.414.414H38.11a.412.412,0,0,0,.414-.414V36.026a.412.412,0,0,0-.414-.414Z",
    transform: "translate(-35 -35)",
    fill: "#52b33a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33785",
    "data-name": "Group 33785",
    transform: "translate(2 6.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143147",
    "data-name": "Path 143147",
    d: "M5.11,39.136H3.026A1.026,1.026,0,0,1,2,38.11V36.026A1.026,1.026,0,0,1,3.026,35h2.8a.307.307,0,0,1,.306.306v2.8A1.026,1.026,0,0,1,5.11,39.136ZM3.026,35.613a.412.412,0,0,0-.414.414V38.11a.412.412,0,0,0,.414.414H5.11a.412.412,0,0,0,.414-.414v-2.5Z",
    transform: "translate(-2 -35)",
    fill: "#52b33a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33786",
    "data-name": "Group 33786",
    transform: "translate(6.864 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143148",
    "data-name": "Path 143148",
    d: "M38.11,6.136h-2.8A.307.307,0,0,1,35,5.83v-2.8A1.026,1.026,0,0,1,36.026,2H38.11a1.026,1.026,0,0,1,1.026,1.026V5.11A1.026,1.026,0,0,1,38.11,6.136Zm-2.5-.613h2.5a.412.412,0,0,0,.414-.414V3.026a.412.412,0,0,0-.414-.414H36.026a.412.412,0,0,0-.414.414Z",
    transform: "translate(-35 -2)",
    fill: "#52b33a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33787",
    "data-name": "Group 33787",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143149",
    "data-name": "Path 143149",
    d: "M5.83,6.136h-2.8A1.026,1.026,0,0,1,2,5.11V3.026A1.026,1.026,0,0,1,3.026,2H5.11A1.026,1.026,0,0,1,6.136,3.026v2.8a.307.307,0,0,1-.306.306Zm-2.8-3.523a.412.412,0,0,0-.414.414V5.11a.412.412,0,0,0,.414.414h2.5v-2.5a.412.412,0,0,0-.414-.414Z",
    transform: "translate(-2 -2)",
    fill: "#52b33a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategorySvg);
export default __webpack_public_path__ + "static/media/CategorySvg.1c7015a1e69c31df35fae3e44d5714af.svg";
export { ForwardRef as ReactComponent };